// src/features/products/productsApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Urls from "../../components/Url/Urls";


export const productsApi = createApi({
  reducerPath: 'productsApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.product.get }),
  tagTypes: ['productsApi'],
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: () => "getProducts",
      keepUnusedDataFor: 35,
      providesTags: ['productsApi'], 
      invalidatesTags: ['productsApi'], 
    }),
    createProduct: builder.mutation({
      query: (newProduct) => {
        const formData = new FormData();
        Object.entries(newProduct).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.product.post,
          method: 'POST',
          body: formData,
         
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['productsApi'], 
    }),
    updateProduct: builder.mutation({
      query: (productData) => {
        const formData = new FormData();
        Object.entries(productData).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.product.update + productData.Id,
          method: 'PUT',
          body: formData
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['productsApi'],
    }),
  
    deleteProduct: builder.mutation({
      query: (Id) => ({
        url: Urls.product.delete + Id,
        method: 'DELETE',
      }),
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['productsApi'], 
    }),

  }),
  keepUnusedDataFor: 1,
  refetchOnMountOrArgChange: true,
  refetchInterval: 1000,
  
});


export const getProductsUnderReOrderLevelApi = createApi({
  reducerPath: 'getProductsUnderReOrderLevelApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.product.underLevel }),
  endpoints: (builder) => ({
    getProductsUnderReOrderLevel: builder.query({
      query: () => 'getProductsUnderReOrderLevel',
    })
  })
});







export const {
  useGetProductsQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
} = productsApi;


export const {
  useGetProductsUnderReOrderLevelQuery
} = getProductsUnderReOrderLevelApi






